import { Response, Server } from 'miragejs';

import {
  frameThatFailsToActivate,
  frameThatFailsToActivateNoDraft,
  frameThatFailsToArchive,
  frameThatFailsToArchiveNoDraft,
  frameThatFailsToDeactivate,
  frameThatFailsToDeactivate2,
  frameThatFailsToDeactivateNoDraft,
  frameThatFailsToDeactivateNoDraft2,
  frameThatFailsToUnarchive,
  frameThatFailsToUnarchiveNoDraft,
} from 'mocks/server/data/frames';
import LocalStorageManager from 'mocks/server/localStorageManager';
import { handleSetStatus } from 'mocks/server/utils/entityUtils';
import { ILiveFrame } from 'types/detailsEntityType';
import {
  FRAMES_ACTIVATE_API_URL,
  FRAMES_API_URL,
  FRAMES_ARCHIVE_API_URL,
  FRAMES_DEACTIVATE_API_URL,
  FRAMES_UNARCHIVE_API_URL,
} from 'utils/defaults';
import { LiveStatus } from 'utils/statuses';

export const framesRoutes = (server: Server, frameStore: LocalStorageManager<ILiveFrame>) => {
  server.get(`${FRAMES_API_URL}/:spaceId`, (schema, request) => {
    const spaceId = request.params.spaceId;
    const frame = frameStore.getById(spaceId);
    if (!frame) {
      return new Response(404, {}, { error: 'Frame not found' });
    }
    return frame;
  });

  server.patch(FRAMES_DEACTIVATE_API_URL, (schema, request) => {
    const data = request.requestBody;
    return handleSetStatus(
      data,
      [frameThatFailsToDeactivate.spaceId, frameThatFailsToDeactivate2.spaceId],
      [frameThatFailsToDeactivateNoDraft.spaceId, frameThatFailsToDeactivateNoDraft2.spaceId],
      'deactivation',
      frameStore,
      LiveStatus.INACTIVE
    );
  });

  server.patch(FRAMES_ACTIVATE_API_URL, (schema, request) => {
    const data = request.requestBody;
    return handleSetStatus(
      data,
      [frameThatFailsToActivate.spaceId],
      [frameThatFailsToActivateNoDraft.spaceId],
      'activation',
      frameStore,
      LiveStatus.ACTIVE
    );
  });

  server.patch(FRAMES_ARCHIVE_API_URL, (schema, request) => {
    const data = request.requestBody;
    return handleSetStatus(
      data,
      [frameThatFailsToArchive.spaceId],
      [frameThatFailsToArchiveNoDraft.spaceId],
      'archiving',
      frameStore,
      LiveStatus.ARCHIVED
    );
  });

  server.patch(FRAMES_UNARCHIVE_API_URL, (schema, request) => {
    const data = request.requestBody;
    return handleSetStatus(
      data,
      [frameThatFailsToUnarchive.spaceId],
      [frameThatFailsToUnarchiveNoDraft.spaceId],
      'unarchiving',
      frameStore,
      LiveStatus.INACTIVE
    );
  });
};
